import { PlanType } from '@showbie-socrative/socrative-utils';

import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { PaywallScreens } from '~analytics/types';
import { EventTypes } from '~analytics/types';

export type AiFeatureType = 'generate' | 'copypaste' | 'extract';
export type QuotaLimitType = 'soft' | 'hard';

export interface AiQuotaUpgradedEventAdapterParams {
  featureType: AiFeatureType;
  limitType: QuotaLimitType;
  percentUsed: number;
  currentPlan: PlanType;
}

const PAYWALL_SCREEN_MAP: Record<
  AiFeatureType,
  Record<QuotaLimitType, PaywallScreens>
> = {
  generate: {
    soft: PaywallScreens.QuizEditGenerateQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditGenerateQuestionsHardLimit,
  },
  copypaste: {
    soft: PaywallScreens.QuizEditCopyPasteQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditCopyPasteQuestionsHardLimit,
  },
  extract: {
    soft: PaywallScreens.QuizEditExtractQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditExtractQuestionsHardLimit,
  },
};

type AiQuotaUpgradedEventData = {
  bucket: AiFeatureType;
  quota_used_percent: number;
  current_plan: PlanType;
  source: PaywallScreens;
  click: 'upgrade';
};

export class AiQuotaUpgradedEventAdapter extends EventAdapter<AiQuotaUpgradedEventData> {
  protected intercomEventKey = null;

  constructor({
    featureType,
    limitType,
    percentUsed,
    currentPlan,
  }: AiQuotaUpgradedEventAdapterParams) {
    super();

    const paywallScreen = PAYWALL_SCREEN_MAP[featureType][limitType];

    this.eventData = {
      bucket: featureType,
      quota_used_percent: percentUsed,
      current_plan: currentPlan,
      source: paywallScreen,
      click: 'upgrade',
    };
  }

  protected amplitudeEventFunction = function aiQuotaUpgradedEvent(
    event: AiQuotaUpgradedEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.PaywallTouch, event);
  };
}
